import akcFactoryMeta from "../coraWebComponents/meta/akcFactory";

const akcFactory = (akc, state, showMsg, obj) => {
const props = { 
    primaryField: state.primaryField, 
    selected: state[state.primaryField].selected || [], 
    printItems: state[state.primaryField].printItems || [],
    data: state[state.primaryField].data || [],
    detailData: state[state.primaryField].detailData,
    gridSchema: state.gridSchema || [],
    showMsg, 
    obj 
};

  switch(akc) {
    default:
      return akcFactoryMeta(akc, state, showMsg, obj);
  }
}

export default akcFactory;
